import { useGetAccountQuery } from '@/services/accounts';
import { ReviewPackageActions } from '@/types/ReviewPackage';
import { Task } from '@/types/Tasks';
import { useParams } from 'react-router-dom';

import { ProgramType } from 'types';

import { ActivationEnergyBackupPackage } from './ActivationEnergyBackupPackage';
import { ActivationPackage } from './ActivationPackage';
import { LegacyActivationPackage } from './LegacyActivationPackage';

export const ActivationMilestonePackageFactory = ({
  legacyReviewTasks,
  canSubmitActivationPackage,
}: {
  legacyReviewTasks: Task[];
  canSubmitActivationPackage: boolean;
}) => {
  const { id } = useParams<{ id: any; action: ReviewPackageActions }>();
  const { data: account } = useGetAccountQuery(id);

  if (legacyReviewTasks?.length > 0) {
    return <LegacyActivationPackage />;
  }

  switch (account?.programType) {
    case ProgramType.solar:
    case ProgramType.doePr:
    case ProgramType.newCommunity:
    case ProgramType.newHomes:
    case ProgramType.consumerSolar:
      return <ActivationPackage canSubmitActivationPackage={canSubmitActivationPackage} />;
    case ProgramType.energyBackup:
      return <ActivationEnergyBackupPackage canSubmitActivationPackage={canSubmitActivationPackage} />;
    case ProgramType.geothermal:
      // Geothermal has no activation milestone (Pattern C: IAD → NTP → Loop Field → Install)
      return null;
    default:
      return null;
  }
};
